
define(
	'Tavanoteam.HazardousProducts.HazardousProducts'
	, [
		'Tavanoteam.HazardousProducts.HazardousProducts.View'
		, 'Tavanoteam.HazardousProducts.AddHazmatFee'
		, 'Tavanoteam.HazardousProducts.HideHazmatFee'
	]
	, function (
		HazardousProductsView
		, AddHazmatFee
		, HideHazmatFee
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {

				AddHazmatFee.mountToApp(container);
				HideHazmatFee.mountToApp(container);

				/** @type {LayoutComponent} */
				var layoutComponent = container.getComponent('Layout');
				var pdpComponent = container.getComponent('PDP');

				if (layoutComponent) {
					layoutComponent.addChildView('Product.Price', function () {
						return new HazardousProductsView({ container: container });
					});
				}
			}
		};
	});
